<template>
  <el-dialog :title="title" :visible.sync="open" :before-close="close" :append-to-body="true" width="700px">
    <div @keyup.enter="checkValidityForm">
      <div class="container-name-color">
        <form-group label="Name" required>
          <template slot="input">
            <input name="name" v-model="bubble.name" :class="{ input: true }" type="text" placeholder="Name" />
          </template>
        </form-group>

        <form-group label="Color">
          <template slot="input">
            <swatches v-model="bubble.color" row-length="6" show-border popover-to="left" colors="basic"></swatches>
          </template>
        </form-group>
      </div>

      <form-group label="Description">
        <template slot="input">
          <input name="description" v-model="bubble.description" />
        </template>
      </form-group>

      <form-group label="Tags">
        <template slot="input">
          <tags element-id="tags" v-model="bubble.tags" :typeahead="true"></tags>
        </template>
      </form-group>

      <div class="container-period-type">
        <form-group label="Type" required>
          <template slot="input">
            <el-radio-group v-model="bubble.type" :disabled="!!id">
              <el-radio-button label="action">Rules</el-radio-button>
              <el-radio-button label="import">Import users</el-radio-button>
            </el-radio-group>
          </template>
        </form-group>

        <form-group label="Period" required v-if="bubble.type === 'action'">
          <template slot="input">
            <el-date-picker
              v-model="period"
              type="daterange"
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="onChangePeriod"
            >
            </el-date-picker>
          </template>

          <template slot="footer">
            <input v-show="false" name="datestart" v-model="bubble.datestart" type="text" />
            <input v-show="false" name="dateend" v-model="bubble.dateend" type="text" />
          </template>
        </form-group>

        <form-group label="Import" required v-if="bubble.type === 'import' && !id">
          <template slot="input">
            <el-input v-model="inputImported" @keyup.enter.native="addUsers">
              <template slot="append">
                <label @click="addUsers" style="cursor:pointer">
                  <font-awesome-icon icon="plus"></font-awesome-icon>
                </label>
              </template>
            </el-input>
          </template>
        </form-group>
      </div>

      <form-group label="Rules" required v-if="bubble.type === 'action'">
        <template slot="input">
          <div class="container-rules">
            <el-select v-model="bubble.request[0].actions[0]" placeholder="Select an event" filterable>
              <el-option v-for="event in events" :key="event.id" :label="event.alias" :value="event.alias"></el-option>
            </el-select>
            <el-select placeholder="Select an operator" v-model="bubble.request[0].comparator">
              <el-option label="=" value="$eq"></el-option>
              <el-option label=">" value="$gt"></el-option>
              <el-option label="<" value="$lt"></el-option>
            </el-select>
            <el-input-number :min="0" v-model="bubble.request[0].tresholdvalue"></el-input-number>
          </div>
        </template>
        <template slot="footer">
          <input v-show="false" name="action" v-model="bubble.request[0].actions[0]" type="text" />

          <input v-show="false" name="comparator" v-model="bubble.request[0].comparator" type="text" />

          <input v-show="false" name="treesholdvalue" v-model="bubble.request[0].tresholdvalue" type="text" />
        </template>
      </form-group>

      <div class="form-group" style="height:140px;" v-if="bubble.type === 'import' && !id" v-bar>
        <div>
          <span class="tag" v-for="(value, index) in bubble.emails" :key="index">
            <span>{{ value }}</span>
            <span @click="bubble.emails.splice(index, 1)"><font-awesome-icon icon="times"></font-awesome-icon></span>
          </span>
          <span class="tag" v-for="(value, index) in bubble.uuids" :key="index">
            <span>{{ value }}</span>
            <span @click="bubble.uuids.splice(index, 1)"><font-awesome-icon icon="times"></font-awesome-icon></span>
          </span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" plain>{{ $t('common.cancel') }}</el-button>
      <el-button
        type="primary"
        @click="checkValidityForm('save-as')"
        v-if="id && bubble.type !== 'import'"
        :loading="isSavingAs"
        >{{ $t('common.save-as') }}</el-button
      >
      <el-button type="primary" @click="checkValidityForm" :loading="isSaving">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dropdown from '@/components/dropdown.vue'
import formGroup from '@/components/layouts/form-group.vue'
import swatches from 'vue-swatches'

export default {
  name: 'bubble-form',
  props: {
    id: {
      type: String,
      required: false
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  components: {
    dropdown,
    formGroup,
    swatches
  },
  data() {
    return {
      bubble: {},
      period: null,
      inputImported: null,
      inputVisible: false,
      inputValue: '',

      isSaving: false,
      isSavingAs: false
    }
  },

  computed: {
    ...mapGetters('bubbles', {
      getById: 'getById'
    }),
    ...mapGetters('events', {
      events: 'events'
    }),
    ...mapGetters('account', {
      site: 'currentSite'
    }),

    title() {
      if (this.id) {
        return 'Edit a bubble'
      } else {
        return 'Create a bubble'
      }
    },

    users() {
      if (this.bubble.emails && this.bubble.uuids) {
        return this.bubble.emails.concat(this.bubble.uuids)
      }
      return []
    }
  },
  methods: {
    ...mapActions('bubbles', ['addBubble', 'updateBubble', 'removeBubble']),
    ...mapActions('events', ['loadEvents']),

    checkValidityForm(type) {
      if (type === 'save-as') {
        return this.saveAs()
      } else {
        return this.save()
      }
    },

    save() {
      this.isSaving = true
      if (!this.id) {
        this.addBubble({ bubble: this.bubble })
          .then(() => {
            this.$notify({
              title: 'Success',
              message: this.$root.$t('notifications.bubble.added'),
              type: 'success'
            })
            this.close()
          })
          .catch(response => {
            this.$notify.error({
              title: this.$root.$t('api.' + response.code + '.title'),
              message: this.$root.$t('api.' + response.code + '.message')
            })
            this.isSaving = false
          })
      } else {
        this.updateBubble({ bubble: this.bubble })
          .then(() => {
            this.$notify({
              title: 'Success',
              message: this.$root.$t('notifications.bubble.edited'),
              type: 'success'
            })
            this.close()
          })
          .catch(response => {
            this.$notify.error({
              title: this.$root.$t('api.' + response.code + '.title'),
              message: this.$root.$t('api.' + response.code + '.message')
            })
            this.isSaving = false
          })
      }
      this.bubble.datestart = this._getDate(this.bubble.datestart, this.currentSite.timezone)
      this.bubble.dateend = this._getDate(this.bubble.dateend, this.currentSite.timezone)
    },

    saveAs() {
      this.isSavingAs = true

      let bubble = this._.cloneDeep(this.bubble, false)
      delete bubble.id

      this.addBubble({ bubble: bubble })
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.bubble.added'),
            type: 'success'
          })
          this.close()
        })
        .catch(response => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('api.' + response.code + '.message')
          })
          this.isSavingAs = false
        })
    },
    onChangePeriod(period) {
      if (period && period[0] && period[1]) {
        this.bubble.datestart = this._setDate(period[0], this.currentSite.timezone, true)
        this.bubble.dateend = this._setDate(period[1], this.currentSite.timezone, false)
      } else {
        this.bubble.datestart = null
        this.bubble.dateend = null
      }
    },
    addUsers(e) {
      e.stopPropagation()
      let users = this.inputImported.split(' ')
      users.forEach(user => {
        user = user.replace(/\s/g, '')
        if (user) {
          this.addUser(user)
        }
      })
      this.inputImported = null
    },
    addUser(user) {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (re.test(user)) {
        if (!this.bubble.emails.includes(user)) {
          this.bubble.emails.push(user)
        }
      } else {
        if (!this.bubble.uuids.includes(user)) {
          this.bubble.uuids.push(user)
        }
      }
    },
    close() {
      this.isSaving = false
      this.isSavingAs = false
      this.$emit('close')
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.bubble.tags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  },
  created() {
    this.loadEvents(this.site.sitekey)

    if (this.id) {
      this.bubble = Object.assign({}, this.getById(this.id))
      if (this.bubble.datestart && this.bubble.dateend) {
        this.period = []
        this.period.push(this._getDate(this.bubble.datestart, this.currentSite.timezone))
        this.period.push(this._getDate(this.bubble.dateend, this.currentSite.timezone))
      }
    } else {
      this.bubble = {
        name: null,
        description: null,
        type: 'action',
        color: '#4ECDC4',
        emails: [],
        uuids: [],
        tags: [],
        request: [
          {
            comparator: null,
            actions: [],
            tresholdvalue: null
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group-inline {
  display: flex;
  margin: 12px 0;
  justify-content: center;
  align-items: center;
  label {
    flex: 1;
    font-weight: 600;
  }
  .el-radio-group {
    flex: 1;
    text-align: right;
  }
}
.container {
  display: flex;
  .el-input {
    margin-right: 12px;
  }
}

.container-rules {
  display: flex;
  > * {
    margin-right: 12px;
    &:last-child {
      margin-right: 0;
    }
  }
}

.container-name-color {
  display: grid;
  grid-template-columns: 1fr 42px;
  grid-column-gap: 12px;
}
.container-period-type {
  display: grid;
  grid-template-columns: 297px 1fr;
  grid-column-gap: 12px;
}

.form-group .tag {
  height: 23px;
  padding: 0 12px;
  line-height: 20px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.07);
  color: #707070;
  border-radius: 4px;
  display: inline-block;
  padding: 0 2px 0 8px;
  margin-bottom: 6px;
  > span:first-child {
    height: 23px;
    line-height: 23px;
    float: left;
  }
  > span:last-child {
    padding: 0 4px;
    height: 23px;
    line-height: 23px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customers/bubble-form.vue